import React, {Component} from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { Form, } from 'reactstrap';
import {CardNumber, CardButton} from './prepaidCard';
import {connect} from 'react-redux';
import {RefillPrepaidCard} from './../actions/prepaidCardActions';
import Alert from './Alert/Alert';
import {hideAlert} from './../actions/AlertActions';
import T from 'i18n-react';

const errorMesssagePinkode = <T.text tag='span' text="please_enter_pin"/>;
const errorMesssageDigitCardNumber = <T.text tag='span' text="card_number_digit"/>;
const errorMesssageDigitPin = <T.text tag='span' text="pincode_digit_validation"/>;
const errorMesssageCardNumber = <T.text tag='span' text="please_enter_card_num"/>;

class PrepaidCardPage extends Component{

  constructor(props){
    super(props);
    this.onCardNumberChanged = this.onCardNumberChanged.bind(this);
    this.onPincodeChanged = this.onPincodeChanged.bind(this);
      this.state={
        cardNumber: '',
        errorCardNumber: '',
        pincode: '',
        errorPincode:''
      }

    }
    onCardNumberChanged(e) {
      let values = e.nativeEvent.target.value;
      if (!values) {
       this.setState({errorCardNumber: errorMesssageCardNumber});
      } else if (values && isNaN(values) == true){
        this.setState({errorCardNumber: errorMesssageDigitCardNumber});
      }else {
       this.setState({errorCardNumber:''});
    }
    this.setState({cardNumber:values});
    }

    onPincodeChanged(e){
      let values = e.nativeEvent.target.value;
      if (!values) {
        this.setState({ errorPincode: errorMesssagePinkode});
      }else if (values && isNaN(values) == true ) {
        this.setState({ errorPincode: errorMesssageDigitPin});
      }else {
        this.setState({ errorPincode: ''});
      }
      this.setState({pincode:values});
    }

    refillPrepaidCardClick = ()=> {
        this.props.hideAlert();
       if (!this.state.cardNumber) {
        this.setState({errorCardNumber:errorMesssageCardNumber});
      }  if (!this.state.pincode) {
        this.setState({ errorPincode: errorMesssagePinkode});
      } else {
      this.props.RefillPrepaidCard(this.props.accountId, this.state.cardNumber, this.state.pincode);
      }

    }

    render() {
      const {
        history,
        typeMessage,
        messageText,
        visible
      } = this.props;
    const {cardNumber, pincode, errorCardNumber, errorPincode} = this.state;
    const message= {
      type: typeMessage,
      text: messageText
    }
    return (
    <div className="col col-sm-10 col-md-8">
        <h4 className="title-screen">
          <T.text tag='span' text="with_prepaid_card"/>
        </h4>
        <div className="label-screen">
          <T.text tag='span' text="kiosk_receipt"/>
        </div>
           <form>
            <CardNumber value={cardNumber} error={errorCardNumber} onChange={this.onCardNumberChanged}
              label={<T.text tag='span' text="card_number"/>} name={'cardNumber'}  />
            <CardNumber  value={pincode} error={errorPincode} onChange={this.onPincodeChanged}
              label={<T.text tag='span' text="pincode"/>} name={'pincode'}  />
            <ReactCSSTransitionGroup
                transitionName="appear"
                transitionEnterTimeout={500}
                transitionLeaveTimeout={500}>
              {visible && <Alert  message={message} />}
            </ReactCSSTransitionGroup>
            <CardButton history={history}
                        onClick = {this.refillPrepaidCardClick} />

          </form>
    </div>

)}
}
export default connect((state) =>{
  const {accountId} = state.authReducer;
  const { message, visible, type } = state.alert;
  return {
    accountId,
    typeMessage: type,
    messageText: message,
    visible
  }
}, {
  RefillPrepaidCard, hideAlert
}) (PrepaidCardPage);



{/* <ReactCSSTransitionGroup
transitionName="fade"
transitionEnterTimeout={300}
transitionLeaveTimeout={300}>
 {visible && <Alert  message={message} />}
</ReactCSSTransitionGroup>  */}



// WEBPACK FOOTER //
// ./src/components/PrepaidCardPage.js